module.exports = __webpack_public_path__ + "images/6c5c7ca9a6bbe674d741d43acbd5fdac.svg";